/**
 *
 *
 *
 * Example:
 *
 * ```js
 * var result1 = merge({a: 1}, {b: 2})
 * console.log(result1) // {a: 1, b: 2}
 * var result1 = merge({a: 1}, {a: 2})
 * console.log(result1.a) // 2
 * ```
 *
 * @param {Object} Object to merge
 * @returns {Object} Result of all merge properties
 */
function merge () {
  let result = {}
  function assiginValue (key, val) {
    if (isObject(val)) {
      result[key] = merge(result[key], val)
    } else {
      result[key] = val
    }
  }

  const argumentsArray = Array.from(arguments || [])
  for (let i = 0, len = argumentsArray.length; i < len; i++) {
    forEach(argumentsArray[i], assiginValue)
  }
  return result
}

/**
 * Ierator over an Array or an Object invoking a function for each item
 *
 *
 * @param {Object} obj
 * @param {*} fn
 */
function forEach (obj, fn) {
  if (obj === null || typeof obj === 'undefined') {
    return
  }

  // Force to an Array if something can not iterate
  if (typeof obj !== 'object') {
    obj = [obj]
  }

  if (Array.isArray(obj)) {
    console.log(obj, 'obj')
    for (let i = 0, len = obj.length; i < len; i++) {
      // eslint-disable-next-line no-useless-call
      fn.call(null, i, obj[i], obj)
    }
  } else {
    for (let key in obj) {
      // eslint-disable-next-line no-useless-call
      fn.call(null, key, obj[key], obj)
    }
  }
}

/**
 * Determine if a value is an Object
 *
 * @param {any} value to test
 * @returns {Boolean} True when value is an Object, otherwise false
 */
function isObject (value) {
  return Object.prototype.toString.call(value) === '[object Object]'
}

/**
 * Determine if a value is undefined
 *
 * @param {*} value
 * @returns {Boolean} True when vlaue is undefined, otherwise false
 */
function isUndefined (value) {
  return typeof value === 'undefined'
}

export default {
  merge,
  forEach,
  isObject,
  isUndefined
}
